/* ============================================================
   STREAMPLANET HOMEPAGE — MIDNIGHT AURORA FINAL
   Vanilla JavaScript
   Shopify Horizon / Theme Editor compatible
   Matches final Home Liquid + Family Bundles
   ============================================================ */

(function () {
  'use strict';


  /* ============================================================
     1. PRICING DATA
     ============================================================ */

  const SP_PRICING = {

    annual: {

      Orbit: {
        price: 70,
        period: '/year',
        saving: 'Save $50 annually'
      },

      Horizon: {
        price: 100,
        period: '/year',
        saving: 'Save $56 annually'
      },

      Cosmos: {
        price: 120,
        period: '/year',
        saving: 'Save $60 annually'
      }

    },


    monthly: {

      Orbit: {
        price: 10,
        period: '/month',
        saving: ''
      },

      Horizon: {
        price: 13,
        period: '/month',
        saving: ''
      },

      Cosmos: {
        price: 15,
        period: '/month',
        saving: ''
      }

    }

  };


  const SP_FAMILY_PRICING = {

    annual: {

      Orbit: {
        1: 70,
        2: 130,
        3: 180,
        5: 260
      },

      Horizon: {
        1: 100,
        2: 180,
        3: 250,
        5: 370
      },

      Cosmos: {
        1: 120,
        2: 220,
        3: 300,
        5: 450
      }

    },


    monthly: {

      Orbit: {
        1: 10,
        2: 18,
        3: 25,
        5: 38
      },

      Horizon: {
        1: 13,
        2: 24,
        3: 33,
        5: 49
      },

      Cosmos: {
        1: 15,
        2: 28,
        3: 38,
        5: 56
      }

    }

  };


  const VALID_PLANS = new Set([
    'Orbit',
    'Horizon',
    'Cosmos',
    'Not sure yet'
  ]);


  const VALID_CONNECTIONS = new Set([
    '1',
    '2',
    '3',
    '5',
    'Not sure yet'
  ]);


  const CONTACT_PLACEHOLDERS = {

    'WhatsApp':
      'Phone number with country code',

    'Telegram':
      '@username or Telegram link',

    'Discord':
      'Discord username or user ID',

    'Instagram':
      '@username or profile link',

    'Facebook Messenger':
      'Messenger profile link or username',

    'X (Twitter)':
      '@username or profile link',

    'Signal':
      'Phone number or Signal username',

    'Viber':
      'Phone number with country code',

    'WeChat':
      'WeChat ID',

    'LINE':
      'LINE ID',

    'Email':
      'Preferred email address',

    'SMS / Text Message':
      'Phone number with country code',

    'Other':
      'Your preferred contact detail'

  };


  /* ============================================================
     2. SHARED HELPERS
     ============================================================ */

  function normalizeBilling(mode) {

    return mode === 'monthly'
      ? 'monthly'
      : 'annual';

  }


  function billingLabel(mode) {

    return normalizeBilling(mode) === 'monthly'
      ? 'Monthly'
      : 'Yearly';

  }


  function normalizePlan(plan) {

    return VALID_PLANS.has(plan)
      ? plan
      : 'Not sure yet';

  }


  function normalizeConnections(value) {

    value =
      String(
        value || ''
      );


    return VALID_CONNECTIONS.has(value)
      ? value
      : 'Not sure yet';

  }


  function formatMoney(value) {

    return '$' + String(value);

  }


  function formatUnitPrice(value) {

    if (
      Number.isInteger(value)
    ) {

      return (
        '$' +
        value.toFixed(0) +
        ' per account'
      );

    }


    return (
      '$' +
      value.toFixed(2) +
      ' per account'
    );

  }


  function optionExists(
    select,
    value
  ) {

    if (
      !select ||
      !value
    ) {

      return false;

    }


    return Array
      .from(
        select.options
      )
      .some(
        function (option) {

          return (
            option.value === value
          );

        }
      );

  }


  function setSelectValue(
    select,
    value
  ) {

    if (
      !select ||
      !optionExists(
        select,
        value
      )
    ) {

      return false;

    }


    select.value =
      value;


    return true;

  }


  function safeScrollTo(element) {

    if (!element) {

      return;

    }


    const reduceMotion =

      typeof window.matchMedia ===
        'function' &&

      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    element.scrollIntoView({

      behavior:
        reduceMotion
          ? 'auto'
          : 'smooth',

      block:
        'start'

    });

  }


  function getHashTarget(
    home,
    hash
  ) {

    if (
      !home ||
      !hash ||
      hash.charAt(0) !== '#'
    ) {

      return null;

    }


    const id =
      hash.slice(1);


    if (!id) {

      return null;

    }


    const candidate =
      document.getElementById(id);


    if (!candidate) {

      return null;

    }


    return home.contains(candidate)
      ? candidate
      : null;

  }


  /* ============================================================
     3. INITIALISE ONE STREAMPLANET HOMEPAGE
     ============================================================ */

  function initStreamPlanet(home) {

    if (!home) {

      return;

    }


    /*
      Prevent duplicate listeners if Shopify
      reloads or reorders the section.
    */

    if (
      home.dataset.spInitialized ===
      'true'
    ) {

      return;

    }


    home.dataset.spInitialized =
      'true';


    /* ==========================================================
       ELEMENT REFERENCES
       ========================================================== */

    const billingButtons =

      home.querySelectorAll(
        '[data-sp-billing]'
      );


    /*
      Only actual membership cards.

      Bundle price elements also contain
      data-sp-plan, so a generic selector
      must not be used here.
    */

    const planCards =

      home.querySelectorAll(
        '.sp-plan-card[data-sp-plan], .sp-plan[data-plan]'
      );


    const familyTabs =

      home.querySelectorAll(
        '[data-sp-family-tab]'
      );


    const familyPanels =

      home.querySelectorAll(
        '[data-sp-family-panel]'
      );


    const familyNote =

      home.querySelector(
        '[data-sp-family-note]'
      );


    const familyFootnote =

      home.querySelector(
        '[data-sp-family-footnote]'
      );


    const faqItems =

      home.querySelectorAll(
        '.sp-faq-item'
      );


    const demoSection =

      home.querySelector(
        '#streamplanet-demo'
      );


    const demoForm =

      home.querySelector(
        '#sp-demo-form'
      );


    const demoPlan =

      home.querySelector(
        '#sp-demo-plan'
      );


    /*
      Internal billing field only.

      No name attribute in Liquid.
    */

    const internalBilling =

      home.querySelector(
        '#sp-demo-billing'
      );


    const billingChoice =

      home.querySelector(
        '#sp-demo-billing-choice'
      );


    const connectionsChoice =

      home.querySelector(
        '#sp-demo-connections'
      );


    const contentPreference =

      home.querySelector(
        '#sp-demo-content'
      );


    const optionalPreferences =

      home.querySelector(
        '#sp-demo-optional-preferences'
      );


    const hiddenRequestType =

      home.querySelector(
        '#sp-demo-request-type'
      );


    const hiddenSource =

      home.querySelector(
        '#sp-demo-source'
      );


    const contactMethod =

      home.querySelector(
        '#sp-demo-contact-method'
      );


    const contactDetail =

      home.querySelector(
        '#sp-demo-contact-detail'
      );


    const demoSuccess =

      home.querySelector(
        '#sp-demo-success'
      );


    const formErrors =

      home.querySelector(
        '.sp-form-errors'
      );


    let activeBilling =
      'annual';


    let activeFamilyPlan =
      'Orbit';


    /* ==========================================================
       4. CORE PLAN PRICING
       ========================================================== */

    function updatePlanPricing(mode) {

      mode =
        normalizeBilling(mode);


      planCards.forEach(
        function (card) {

          const planName =

            normalizePlan(

              card.dataset.spPlan ||

              card.dataset.plan ||

              ''

            );


          const pricing =

            SP_PRICING[mode] &&

            SP_PRICING[mode][planName];


          if (!pricing) {

            return;

          }


          const price =

            card.querySelector(
              '[data-sp-price]'
            );


          const period =

            card.querySelector(
              '[data-sp-period]'
            );


          const saving =

            card.querySelector(
              '[data-sp-saving]'
            );


          if (price) {

            price.textContent =

              formatMoney(
                pricing.price
              );

          }


          if (period) {

            period.textContent =

              pricing.period;

          }


          if (saving) {

            saving.textContent =

              pricing.saving;


            saving.classList.toggle(

              'is-empty',

              pricing.saving === ''

            );

          }

        }
      );

    }


    /* ==========================================================
       5. FAMILY BUNDLE PRICING
       ========================================================== */

    function updateFamilyPricing(mode) {

      mode =
        normalizeBilling(mode);


      familyPanels.forEach(
        function (panel) {

          const plan =

            normalizePlan(

              panel.dataset
                .spFamilyPanel ||

              'Not sure yet'

            );


          if (
            plan ===
              'Not sure yet' ||

            !SP_FAMILY_PRICING[mode][plan]
          ) {

            return;

          }


          const planPrices =

            SP_FAMILY_PRICING[mode][plan];


          panel
            .querySelectorAll(
              '[data-sp-bundle-price]'
            )
            .forEach(
              function (priceElement) {

                const count =

                  Number(

                    priceElement
                      .dataset
                      .spConnections

                  );


                if (
                  !planPrices[count]
                ) {

                  return;

                }


                const price =

                  planPrices[count];


                const regularPrice =

                  planPrices[1] *
                  count;


                const savingAmount =

                  regularPrice -
                  price;


                const unitPrice =

                  price /
                  count;


                const card =

                  priceElement.closest(
                    '.sp-bundle-card'
                  );


                const period =

                  card
                    ? card.querySelector(
                        '[data-sp-bundle-period]'
                      )
                    : null;


                const saving =

                  card
                    ? card.querySelector(
                        '[data-sp-bundle-saving]'
                      )
                    : null;


                const unit =

                  card
                    ? card.querySelector(
                        '[data-sp-bundle-unit]'
                      )
                    : null;


                priceElement.textContent =

                  formatMoney(price);


                if (period) {

                  period.textContent =

                    mode === 'annual'
                      ? '/year'
                      : '/month';

                }


                if (saving) {

                  saving.textContent =

                    'Save $' +

                    savingAmount +

                    ' vs ' +

                    count +

                    ' individual accounts';

                }


                if (unit) {

                  unit.textContent =

                    formatUnitPrice(
                      unitPrice
                    );

                }

              }
            );

        }
      );


      if (familyNote) {

        familyNote.textContent =

          mode === 'annual'

            ? 'Annual: yearly player included per account'

            : 'Monthly: paid player not included';

      }


      if (familyFootnote) {

        familyFootnote.textContent =

          mode === 'annual'

            ? 'Annual bundle pricing includes one yearly player license per account.'

            : 'Monthly bundle pricing does not include a paid player license.';

      }

    }


    /* ==========================================================
       6. BILLING STATE
       ========================================================== */

    function setBilling(
      mode,
      options
    ) {

      mode =
        normalizeBilling(mode);


      options =
        options || {};


      activeBilling =
        mode;


      billingButtons.forEach(
        function (button) {

          const isActive =

            button.dataset
              .spBilling ===
            mode;


          button.classList.toggle(
            'active',
            isActive
          );


          button.classList.toggle(
            'is-active',
            isActive
          );


          button.setAttribute(

            'aria-pressed',

            isActive
              ? 'true'
              : 'false'

          );

        }
      );


      updatePlanPricing(mode);

      updateFamilyPricing(mode);


      if (internalBilling) {

        internalBilling.value =
          mode;

      }


      /*
        Do not overwrite "Not sure yet"
        on initial page load.

        Visible billing is synced only
        after an intentional pricing action.
      */

      if (
        options.syncVisiblePreference &&
        billingChoice
      ) {

        setSelectValue(

          billingChoice,

          billingLabel(mode)

        );

      }

    }


    /* ==========================================================
       7. FAMILY PLAN TABS
       ========================================================== */

    function showFamilyPlan(plan) {

      plan =
        normalizePlan(plan);


      if (
        plan ===
        'Not sure yet'
      ) {

        plan =
          'Orbit';

      }


      activeFamilyPlan =
        plan;


      familyTabs.forEach(
        function (tab) {

          const isActive =

            tab.dataset
              .spFamilyTab ===
            plan;


          tab.classList.toggle(
            'active',
            isActive
          );


          tab.setAttribute(

            'aria-selected',

            isActive
              ? 'true'
              : 'false'

          );

        }
      );


      familyPanels.forEach(
        function (panel) {

          const isActive =

            panel.dataset
              .spFamilyPanel ===
            plan;


          panel.classList.toggle(
            'active',
            isActive
          );


          panel.hidden =
            !isActive;

        }
      );

    }


    /* ==========================================================
       8. PLAN / REGION PREFERENCE
       ========================================================== */

    function setContentPreferenceForPlan(
      plan
    ) {

      if (!contentPreference) {

        return;

      }


      /*
        Reset stale preference first.

        Example:
        Cosmos → Orbit should not leave
        "Worldwide" selected.
      */

      if (
        plan === 'Orbit' ||
        plan === 'Not sure yet'
      ) {

        setSelectValue(

          contentPreference,

          'Not sure yet'

        );


        return;

      }


      if (
        plan === 'Horizon'
      ) {

        setSelectValue(

          contentPreference,

          'Broader International'

        );


        return;

      }


      if (
        plan === 'Cosmos'
      ) {

        setSelectValue(

          contentPreference,

          'Worldwide'

        );

      }

    }


    /* ==========================================================
       9. CONNECTION / ACCOUNT PREFILL
       ========================================================== */

    function setConnectionsForDemo(
      plan,
      connections
    ) {

      if (!connectionsChoice) {

        return;

      }


      /*
        BUNDLE CTA:
        Explicitly supplied 2 / 3 / 5.
      */

      if (connections) {

        setSelectValue(

          connectionsChoice,

          normalizeConnections(
            connections
          )

        );


        return;

      }


      /*
        NORMAL PAID PLAN CTA:
        Orbit / Horizon / Cosmos cards are
        single-account plans.

        This fixes the case where somebody
        previously selected a 3-account bundle,
        then clicks a normal plan CTA.
      */

      if (
        plan === 'Orbit' ||
        plan === 'Horizon' ||
        plan === 'Cosmos'
      ) {

        setSelectValue(

          connectionsChoice,

          '1'

        );


        return;

      }


      /*
        GENERIC DEMO CTA:
        Hero, Devices, Sticky CTA etc.
      */

      setSelectValue(

        connectionsChoice,

        'Not sure yet'

      );

    }


    /* ==========================================================
       10. DEMO FORM PREFILL
       ========================================================== */

    function prefillDemo(
      plan,
      source,
      connections
    ) {

      plan =
        normalizePlan(plan);


      connections =

        connections

          ? normalizeConnections(
              connections
            )

          : '';


      /*
        PLAN
      */

      if (demoPlan) {

        setSelectValue(
          demoPlan,
          plan
        );

      }


      /*
        BILLING

        Follow whichever pricing mode
        is active when CTA is clicked.
      */

      if (billingChoice) {

        setSelectValue(

          billingChoice,

          billingLabel(
            activeBilling
          )

        );

      }


      /*
        ACCOUNT / CONNECTION COUNT
      */

      setConnectionsForDemo(
        plan,
        connections
      );


      /*
        SOURCE ATTRIBUTION
      */

      if (hiddenSource) {

        hiddenSource.value =

          source

            ? 'Homepage - ' +
              source

            : 'Homepage Free Demo';

      }


      if (hiddenRequestType) {

        hiddenRequestType.value =
          'Free Demo';

      }


      if (internalBilling) {

        internalBilling.value =
          activeBilling;

      }


      /*
        CONTENT / REGION
      */

      setContentPreferenceForPlan(
        plan
      );


      /*
        Specific plan or bundle CTA:
        show Optional Preferences so the
        user can see what was prefilled.
      */

      if (
        optionalPreferences &&

        (
          plan !==
            'Not sure yet' ||

          connections
        )
      ) {

        optionalPreferences.open =
          true;

      }

    }


    /* ==========================================================
       11. CONTACT DETAIL PLACEHOLDER
       ========================================================== */

    function updateContactPlaceholder() {

      if (!contactDetail) {

        return;

      }


      const method =

        contactMethod

          ? contactMethod.value

          : '';


      contactDetail.placeholder =

        CONTACT_PLACEHOLDERS[method] ||

        'Phone number, username, ID or profile link';

    }


    /* ==========================================================
       12. CLICK HANDLING
       ========================================================== */

    home.addEventListener(

      'click',

      function (event) {


        /* ------------------------------------------------------
           BILLING TOGGLE
           ------------------------------------------------------ */

        const billingButton =

          event.target.closest(
            '[data-sp-billing]'
          );


        if (
          billingButton &&
          home.contains(
            billingButton
          )
        ) {

          event.preventDefault();


          setBilling(

            billingButton
              .dataset
              .spBilling,

            {
              syncVisiblePreference:
                true
            }

          );


          return;

        }


        /* ------------------------------------------------------
           FAMILY PLAN TAB
           ------------------------------------------------------ */

        const familyTab =

          event.target.closest(
            '[data-sp-family-tab]'
          );


        if (
          familyTab &&
          home.contains(
            familyTab
          )
        ) {

          event.preventDefault();


          showFamilyPlan(

            familyTab
              .dataset
              .spFamilyTab

          );


          return;

        }


        /* ------------------------------------------------------
           DEMO CTA
           ------------------------------------------------------ */

        const demoTrigger =

          event.target.closest(
            '.sp-demo-trigger'
          );


        if (
          demoTrigger &&
          home.contains(
            demoTrigger
          )
        ) {

          event.preventDefault();


          prefillDemo(

            demoTrigger
              .dataset
              .spDemoPlan ||

              'Not sure yet',


            demoTrigger
              .dataset
              .spDemoSource ||

              'Homepage',


            demoTrigger
              .dataset
              .spDemoConnections ||

              ''

          );


          safeScrollTo(
            demoSection
          );


          return;

        }


        /* ------------------------------------------------------
           INTERNAL HOMEPAGE ANCHORS
           ------------------------------------------------------ */

        const link =

          event.target.closest(
            'a[href^="#"]'
          );


        if (
          !link ||
          !home.contains(link)
        ) {

          return;

        }


        const href =

          link.getAttribute(
            'href'
          );


        if (
          !href ||
          href === '#'
        ) {

          return;

        }


        const target =

          getHashTarget(
            home,
            href
          );


        if (!target) {

          return;

        }


        event.preventDefault();


        safeScrollTo(
          target
        );

      }

    );


    /* ==========================================================
       13. CHANGE HANDLING
       ========================================================== */

    home.addEventListener(

      'change',

      function (event) {


        /* ------------------------------------------------------
           CONTACT CHANNEL
           ------------------------------------------------------ */

        if (
          event.target ===
          contactMethod
        ) {

          updateContactPlaceholder();

          return;

        }


        /* ------------------------------------------------------
           BILLING PREFERENCE
           ------------------------------------------------------ */

        if (
          event.target ===
          billingChoice
        ) {

          if (
            billingChoice.value ===
            'Monthly'
          ) {

            setBilling(
              'monthly'
            );

          }


          if (
            billingChoice.value ===
            'Yearly'
          ) {

            setBilling(
              'annual'
            );

          }


          return;

        }


        /* ------------------------------------------------------
           PLAN PREFERENCE
           ------------------------------------------------------ */

        if (
          event.target ===
          demoPlan
        ) {

          const selectedPlan =

            normalizePlan(
              demoPlan.value
            );


          setContentPreferenceForPlan(
            selectedPlan
          );


          /*
            If the customer manually selects
            a normal plan in the form after
            previously choosing a family bundle,
            reset to one account.
          */

          if (
            selectedPlan === 'Orbit' ||
            selectedPlan === 'Horizon' ||
            selectedPlan === 'Cosmos'
          ) {

            setSelectValue(

              connectionsChoice,

              '1'

            );

          }


          if (
            selectedPlan ===
            'Not sure yet'
          ) {

            setSelectValue(

              connectionsChoice,

              'Not sure yet'

            );

          }

        }

      }

    );


    /* ==========================================================
       14. FAQ ACCORDION
       ========================================================== */

    faqItems.forEach(
      function (item) {

        item.addEventListener(

          'toggle',

          function () {

            if (!item.open) {

              return;

            }


            faqItems.forEach(
              function (
                otherItem
              ) {

                if (
                  otherItem !==
                    item &&

                  otherItem.open
                ) {

                  otherItem.open =
                    false;

                }

              }
            );

          }

        );

      }
    );


    /* ==========================================================
       15. DEMO FORM SUBMISSION

       Shopify performs actual submission.
       No preventDefault().
       ========================================================== */

    if (demoForm) {

      demoForm.addEventListener(

        'submit',

        function () {


          if (internalBilling) {

            internalBilling.value =
              activeBilling;

          }


          if (hiddenRequestType) {

            hiddenRequestType.value =
              'Free Demo';

          }


          /*
            Prevent repeated clicks while
            Shopify submits the form.
          */

          const submitButton =

            demoForm.querySelector(
              '.sp-demo-submit'
            );


          if (submitButton) {

            window.setTimeout(

              function () {

                submitButton.disabled =
                  true;


                submitButton.setAttribute(

                  'aria-disabled',

                  'true'

                );


                submitButton.style.opacity =
                  '0.72';


                submitButton.style.cursor =
                  'wait';

              },

              0

            );

          }

        }

      );

    }


    /* ==========================================================
       16. INITIAL STATE
       ========================================================== */

    billingButtons.forEach(
      function (button) {

        button.setAttribute(
          'type',
          'button'
        );

      }
    );


    familyTabs.forEach(
      function (tab) {

        tab.setAttribute(
          'type',
          'button'
        );

      }
    );


    const initiallyActiveBillingButton =

      home.querySelector(

        '[data-sp-billing].is-active, ' +

        '[data-sp-billing].active, ' +

        '[data-sp-billing][aria-pressed="true"]'

      );


    if (
      initiallyActiveBillingButton
    ) {

      activeBilling =

        normalizeBilling(

          initiallyActiveBillingButton
            .dataset
            .spBilling

        );

    }


    const initiallyActiveFamilyTab =

      home.querySelector(

        '[data-sp-family-tab].active, ' +

        '[data-sp-family-tab][aria-selected="true"]'

      );


    if (
      initiallyActiveFamilyTab
    ) {

      activeFamilyPlan =

        normalizePlan(

          initiallyActiveFamilyTab
            .dataset
            .spFamilyTab

        );

    }


    /*
      Initial pricing render.

      Does NOT force Billing Preference
      away from "Not sure yet".
    */

    setBilling(
      activeBilling
    );


    showFamilyPlan(
      activeFamilyPlan
    );


    updateContactPlaceholder();


    if (hiddenRequestType) {

      hiddenRequestType.value =
        'Free Demo';

    }


    if (
      demoPlan &&

      !optionExists(
        demoPlan,
        demoPlan.value
      )
    ) {

      setSelectValue(

        demoPlan,

        'Not sure yet'

      );

    }


    if (
      connectionsChoice &&

      !optionExists(
        connectionsChoice,
        connectionsChoice.value
      )
    ) {

      setSelectValue(

        connectionsChoice,

        'Not sure yet'

      );

    }


    /* ==========================================================
       17. SHOPIFY SUCCESS / ERROR RETURN
       ========================================================== */

    if (
      demoSuccess ||
      formErrors
    ) {

      window.setTimeout(

        function () {

          safeScrollTo(
            demoSection
          );

        },

        180

      );

    }


    /* ==========================================================
       18. HOMEPAGE HASH LANDING

       Supports:
       /#streamplanet-plans
       /#familyBundles
       /#sp-devices
       /#sp-setup-guide
       /#sp-guides
       /#sp-faq
       /#streamplanet-demo
       ========================================================== */

    function handleCurrentHash() {

      const hash =
        window.location.hash;


      if (!hash) {

        return;

      }


      const target =

        getHashTarget(
          home,
          hash
        );


      if (!target) {

        return;

      }


      window.setTimeout(

        function () {

          safeScrollTo(
            target
          );

        },

        120

      );

    }


    handleCurrentHash();


    /* ==========================================================
       19. PUBLIC API
       ========================================================== */

    window.StreamPlanet =

      window.StreamPlanet || {};


    window.StreamPlanet.openDemo =

      function (
        plan,
        source,
        connections
      ) {

        prefillDemo(

          plan ||
            'Not sure yet',

          source ||
            'Website',

          connections ||
            ''

        );


        safeScrollTo(
          demoSection
        );

      };


    window.StreamPlanet.setBilling =

      function (mode) {

        setBilling(

          mode,

          {
            syncVisiblePreference:
              true
          }

        );

      };


    window.StreamPlanet.showFamilyPlan =

      function (plan) {

        showFamilyPlan(
          plan
        );

      };

  }


  /* ============================================================
     20. INITIALISE ALL STREAMPLANET HOME SECTIONS
     ============================================================ */

  function initAllStreamPlanetHomes(
    root
  ) {

    root =
      root || document;


    if (
      root.matches &&

      root.matches(
        '.sp-home'
      )
    ) {

      initStreamPlanet(
        root
      );

    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          '.sp-home'
        )
        .forEach(
          initStreamPlanet
        );

    }

  }


  function initialBoot() {

    initAllStreamPlanetHomes(
      document
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(

      'DOMContentLoaded',

      initialBoot,

      {
        once: true
      }

    );

  } else {

    initialBoot();

  }


  /* ============================================================
     21. SHOPIFY THEME EDITOR SUPPORT
     ============================================================ */

  if (
    !window
      .__streamPlanetThemeEditorListener
  ) {

    window
      .__streamPlanetThemeEditorListener =
        true;


    document.addEventListener(

      'shopify:section:load',

      function (event) {

        initAllStreamPlanetHomes(
          event.target
        );

      }

    );


    document.addEventListener(

      'shopify:section:reorder',

      function () {

        initAllStreamPlanetHomes(
          document
        );

      }

    );

  }


  /* ============================================================
     22. HASH CHANGES FROM HEADER / FOOTER

     Important for:
     /#familyBundles
     /#sp-setup-guide
     etc.
     ============================================================ */

  if (
    !window
      .__streamPlanetHashListener
  ) {

    window
      .__streamPlanetHashListener =
        true;


    window.addEventListener(

      'hashchange',

      function () {

        const hash =
          window.location.hash;


        if (!hash) {

          return;

        }


        const target =

          document.getElementById(

            hash.slice(1)

          );


        if (
          !target ||

          !target.closest(
            '.sp-home'
          )
        ) {

          return;

        }


        window.setTimeout(

          function () {

            safeScrollTo(
              target
            );

          },

          60

        );

      }

    );

  }

})();